/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsEventTypesEnum } from './vcdsEventTypesEnum';
import { BackupOperationEnum } from './backupOperationEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { TaskResourceType } from './taskResourceType';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { VcdsEventSubTypesEnum } from './vcdsEventSubTypesEnum';


export interface EventBackupSpec { 
    event_id?: string;
    event_sub_type?: VcdsEventSubTypesEnum;
    event_type?: VcdsEventTypesEnum;
    operation: BackupOperationEnum;
    resource_type?: TaskResourceType;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * The start period of the retention/ purge
     */
    start_date?: Date;
    /**
     * The end period of the retention/ purge
     */
    end_date?: Date;
    /**
     * Execute the operation in dry-run mode. When true, performs validation and query matching but skips actual database modifications.
     */
    dry_run?: boolean;
}
export namespace EventBackupSpec {
}


